import * as Sentry from '@sentry/react';
import * as React from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useRouteError } from 'react-router-dom';
import Button from './Button.tsx';

// the router catches an error thrown while rendering a page, so it never reaches Sentry's global handler
const PageError = () => {
    const { t } = useTranslation('errors');
    const error = useRouteError();

    useEffect(() => {
        Sentry.captureException(error);
    }, [error]);

    return (
        <div className="w-full h-dvh flex items-center justify-center">
            <div className="w-[30rem] text-center flex flex-col gap-6">
                <h2 className="text-content-strong text-xl font-medium">{t('pageError.title')}</h2>
                <p className="text-content-medium text-base">{t('pageError.text')}</p>
                <div>
                    <Button onClick={() => window.location.reload()}>{t('pageError.button')}</Button>
                </div>
            </div>
        </div>
    );
};

export default PageError;
